import type { VolumePoint } from '../types/voip';

function noise(seed: number, i: number): number {
  const x = Math.sin(seed * 97.13 + i * 12.9898) * 43758.5453;
  return x - Math.floor(x);
}

/** Distributes a user's share of team volume across the range, tilted by their trend */
export function buildSeries(points: VolumePoint[], share: number, trend: number, seed: number): number[] {
  const n = points.length;
  return points.map((p, i) => {
    const base = (p.outbound + p.inbound + p.missed) * share;
    const tilt = 1 + (trend / 100) * (n > 1 ? (i / (n - 1) - 0.5) * 2 : 0);
    const jitter = 0.8 + noise(seed, i) * 0.4;
    return Math.max(0, Math.round(base * tilt * jitter * 10) / 10);
  });
}

export function sumSeries(list: number[][]): number[] {
  if (list.length === 0) return [];
  return list[0].map((_, i) => Math.round(list.reduce((s, arr) => s + (arr[i] ?? 0), 0) * 10) / 10);
}
